var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PageTitle',{attrs:{"title":"Stök námskeið"}}),_c('PageMenu',{attrs:{"route":"SingleClasses","selectedPage":_vm.page,"items":_vm.menu}}),(_vm.page === 'classes')?_c('Classes'):_vm._e(),(_vm.page === 'certificate')?_c('Certificates'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }